// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"66615cf9","455":"eedabd2a","977":"29931747"}[chunkId] + ".chunk.js";
};